import { useNavigate } from 'react-router-dom'

import { BaseBanner } from '@factorialco/f0-react/dist/experimental'
import HomologationFeatureImage from 'assets/images/expenses/expenses-homologation-feature.png'
import { LOCAL_STORAGE_KEYS_FACTORIAL_TIPS } from 'config/Vars'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

const SigningFeatureAcceptTermsBanner = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const [bannerIsHidden, setBannerIsHidden] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS_FACTORIAL_TIPS.hideAcceptTermsBannerForExpenses
  )

  const handleClose = () => {
    setBannerIsHidden(true)
  }

  if (bannerIsHidden) return null

  return (
    <BaseBanner
      title={i18n.t('expenses_v2.banners.legal_compliance.title_v2')}
      subtitle={i18n.t('expenses_v2.banners.legal_compliance.description_v2')}
      mediaUrl={HomologationFeatureImage}
      secondaryAction={{
        label: i18n.t('expenses_v2.banners.legal_compliance.button_v2'),
        onClick: () => {
          navigate({
            pathname: navigation.settings.expenses.fullPath(),
            search: 'legal-compliance',
          })
        },
      }}
      onClose={handleClose}
    />
  )
}

export default SigningFeatureAcceptTermsBanner
